import Grid from '@material-ui/core/Grid';
import GS from '../../grafsync/grafsync';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';

class UpdateSubscriptionDialog extends React.Component {

    constructor(props) {
        super(props);
        const subscriptionType = props.subscription.subscriptionType;
        const subscriptionOptions = GS.subscriptionOptions();
        const maxTriplesAllowed = subscriptionOptions.find(option => option.subscriptionType === subscriptionType).maxTriples;
        const maxImportSize = subscriptionOptions.find(option => option.subscriptionType === subscriptionType).maxImportSize;
        this.state = {
            subscriptionVersion: props.subscription.hasOwnProperty("subscriptionVersion") ?
                props.subscription.subscriptionVersion
                :
                0,
            maxUsers: props.subscription.maxUsers || 0,
            maxTriples: props.subscription.maxTriples || maxTriplesAllowed,
            maxImportSize: props.subscription.maxImportSize || maxImportSize
        };
    }

    updateSubscription = () => {
        const { maxUsers, maxTriples, maxImportSize, subscriptionVersion } = this.state;
        this.props.onUpdate({
            maxUsers,
            maxTriples,
            maxImportSize,
            subscriptionVersion
        });
    };

    exitUpdateSubscription = () => this.props.onCancel();

    handleMaxUsersChange = (event) => {
        const t = event.target;
        let value = t.value !== "" ? parseInt(t.value) : 0;
        if (value < this.props.subscription.maxUsers) value = this.props.subscription.maxUsers;
        if (value > 1000) value = 1000;
        this.setState({
            maxUsers: value
        });
    };

    handleMaxTriplesChange = (event) => {
        const t = event.target;
        let value = t.value !== "" ? parseInt(t.value) : 0;
        if (value < 100000) value = 100000;
        this.setState({
            maxTriples: value
        });
    };

    handleMaxImportSizeChange = (event) => {
        const t = event.target;
        let value = t.value !== "" ? parseInt(t.value) : 0;
        this.setState({
            maxImportSize: value
        });
    };

    handleVersionChange = (event) => {
        const t = event.target;
        let value = t.value !== "" ? parseInt(t.value) : 0;
        if (value > 5) value = 5;
        this.setState({
            subscriptionVersion: value
        });
    };

    render() {

        const { classes } = this.props;
        const { maxUsers, maxTriples, maxImportSize, subscriptionVersion } = this.state;

        let importSizeInvalid = maxImportSize < 1 || maxImportSize > 1000;
        let invalid = importSizeInvalid;

        return (
            <React.Fragment>
                <Dialog className={classes.dialog}
                    open={true}
                    maxWidth="sm"
                    fullWidth
                    onClose={this.exitUpdateSubscription} aria-labelledby="update-subscription-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="update-subscription-dialog-title">Update Subscription</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} classes={
                            {
                                "spacing-xs-2": this.props.classes.fullGrid
                            }
                        }>
                            <Grid item xs={4}>
                                <TitledPanel title="Max Users">
                                    <TextField
                                        onChange={this.handleMaxUsersChange}
                                        InputProps={{
                                            inputProps: {
                                                "data-test": "update-max-users",
                                                "min": this.props.subscription.maxUsers,
                                                "max": 1000
                                            },
                                            className: classes.inputLabel
                                        }}
                                        variant="outlined"
                                        type="number"
                                        value={maxUsers} />
                                </TitledPanel>
                            </Grid>
                            <Grid item xs={4}>
                                <TitledPanel title="Max Triples">
                                    <TextField
                                        onChange={this.handleMaxTriplesChange}
                                        InputProps={{
                                            inputProps: {
                                                "data-test": "update-max-triples",
                                                "min": 100000,
                                                "max": 50000000
                                            },
                                            className: classes.inputLabel
                                        }}
                                        variant="outlined"
                                        type="number"
                                        value={maxTriples} />
                                </TitledPanel>
                            </Grid>
                            <Grid item xs={4}>
                                <TitledPanel title="Max Import Size (MB)">
                                    <TextField
                                        onChange={this.handleMaxImportSizeChange}
                                        InputProps={{
                                            inputProps: {
                                                "data-test": "update-max-import-size"
                                            },
                                            className: classes.inputLabel
                                        }}
                                        error={importSizeInvalid}
                                        helperText={importSizeInvalid ? <span data-test="helper-text">Must be 1-1000</span> : null}
                                        variant="outlined"
                                        type="number"
                                        value={maxImportSize} />
                                </TitledPanel>
                            </Grid>
                            <Grid item xs={4}>
                                <TitledPanel title="Version">
                                    <TextField
                                        onChange={this.handleVersionChange}
                                        InputProps={{
                                            inputProps: {
                                                "data-test": "update-version",
                                                "min": 0,
                                                "max": 5
                                            },
                                            className: classes.inputLabel
                                        }}
                                        variant="outlined"
                                        type="number"
                                        value={subscriptionVersion} />
                                </TitledPanel>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitUpdateSubscription} />
                        <PrimaryButton disabled={invalid} onClick={this.updateSubscription}>Update</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

UpdateSubscriptionDialog.propTypes = {
    classes: PropTypes.object,
    onUpdate: PropTypes.func.isRequired,
    subscription: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default withStyles(styles)(UpdateSubscriptionDialog);